import { Paper, Typography, useTheme } from "@mui/material";
import useStyles from "./styles";
import { ArrowDropDown, ArrowForward, EventNote } from "@mui/icons-material";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import ModalDateTime from "./modalDateTime";

const DateFilter = forwardRef((props, ref) => {
  const { disabled, filtersState, setFilterState } = props;
  const theme = useTheme();

  const styles = useStyles(theme);
  const [anchorElDate, setAnchorElDate] = useState(null);
  const optionsTimesRange = [
    { value: 5, unit: "minutos", unitEn: "minutes", type: "ago" },
    { value: 15, unit: "minutos", unitEn: "minutes", type: "ago" },
    { value: 30, unit: "minutos", unitEn: "minutes", type: "ago" },
    { value: 1, unit: "hora", unitEn: "hour", type: "ago" },
    { value: 3, unit: "horas", unitEn: "hours", type: "ago" },
    { value: 6, unit: "horas", unitEn: "hours", type: "ago" },
    { value: 12, unit: "horas", unitEn: "hours", type: "ago" },
    { value: 24, unit: "horas", unitEn: "hours", type: "ago" },
    { value: 2, unit: "dias", unitEn: "days", type: "ago" },
    { value: 7, unit: "dias", unitEn: "days", type: "ago" },
  ];

  const [filtersStateLocal, setFiltersStateLocal] = useState({
    timeStart: filtersState.timeStart,
    timeEnd: filtersState.timeEnd,
    option: filtersState.option,
  });

  useEffect(() => {
    setFiltersStateLocal({
      timeStart: filtersState.timeStart,
      timeEnd: filtersState.timeEnd,
      option: filtersState.option,
    });
  }, [filtersState]);

  const handleClick = (event) => {
    setAnchorElDate(event.currentTarget);
  };

  const textOptions = (option) => {
    if (option.type === "ago") {
      return ` ${option.value} ${option.unit} atrás`;
    }
    if (option.type === "current") {
      return `${option.unit} atual`;
    }
    if (option.type === "previous") {
      return `${option.unit} anterior`;
    }
  };
  const handleChangeDateFilter = (valueParam) => {
    const { timeStart, timeEnd, option } = valueParam ?? {
      timeStart: new Date(new Date().setHours(new Date().getHours() - 24)),
      timeEnd: new Date(),
      option: null,
    };

    setFiltersStateLocal((data) => ({
      timeStart: timeStart,
      timeEnd: timeEnd,
      option: option,
    }));
  };

  const handleApplyFilters = () => {
    const start = new Date(filtersStateLocal.timeStart);
    start.setSeconds(0, 0);
    const end = new Date(filtersStateLocal.timeEnd);
    end.setSeconds(0, 0);

    const payload = {
      timeStart: start?.toISOString(),
      timeEnd: end?.toISOString(),
      option: filtersStateLocal.option,
    };

    setFilterState(payload);
  };
  const handleResetFilters = () => {
    const resetValue = {
      timeStart: new Date(
        new Date().setHours(new Date().getHours() - 24),
      ).toISOString(),
      timeEnd: new Date().toISOString(),
      option: null,
    };

    setFilterState(resetValue);
    setFiltersStateLocal({
      timeStart: resetValue.timeStart,
      timeEnd: resetValue.timeEnd,
      option: resetValue.option,
    });
  };
  useImperativeHandle(ref, () => ({
    handleReset: handleResetFilters,
  }));

  return (
    <>
      <Paper
        sx={{
          ...styles.paper,
          ...(filtersStateLocal.option && {
            maxWidth: "184.14px",
            minWidth: "184.14px",
          }),
        }}
        onClick={(e) => handleClick(e)}
        elevation={0}
      >
        <EventNote sx={{ fontSize: 20, color: "text.secondary" }} />
        {filtersStateLocal.option ? (
          <>
            <Typography sx={styles.typography}>
              {textOptions(filtersStateLocal.option)}
            </Typography>
          </>
        ) : (
          <>
            <Typography sx={styles.typography}>
              {filtersStateLocal.timeStart &&
                new Date(filtersStateLocal.timeStart).toLocaleDateString(
                  "pt-BR",
                  {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  },
                )}
            </Typography>
            <ArrowForward sx={{ fontSize: 20, color: "text.secondary" }} />
            <Typography sx={styles.typography}>
              {filtersStateLocal.timeEnd &&
                new Date(filtersStateLocal.timeEnd).toLocaleDateString(
                  "pt-BR",
                  {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  },
                )}
            </Typography>
          </>
        )}
        <ArrowDropDown sx={{ fontSize: 20, color: "text.secondary" }} />
      </Paper>

      <ModalDateTime
        optionsTimesRange={optionsTimesRange}
        key={"modalDate"}
        anchorEl={anchorElDate}
        setAnchorEl={setAnchorElDate}
        value={filtersStateLocal}
        onChange={handleChangeDateFilter}
        onClose={handleApplyFilters}
        disabled={disabled}
      />
    </>
  );
});
export default DateFilter;
